import * as moment from 'moment'
import { stripUndefined } from '../../../_utils/strip-undefined'
import type { Journey } from '../types/journey-api-response'
import { ExitBehavior, ExitStatus } from '@pushly/models/lib/enums/journeys'

export function serializeJourney(journey: Journey): Record<string, any> {
    const data: Record<string, any> = structuredClone(journey)

    // Map type field to API expectation
    data.campaign_type = data.type ?? data.campaign_type

    // Format dates
    if (data.date_start) {
        data.date_start = moment(data.date_start).format('YYYY-MM-DD HH:mm')
    }

    if (data.date_end) {
        data.date_end = moment(data.date_end).format('YYYY-MM-DD HH:mm')
    } else {
        data.date_end = null
    }

    // Default timezone
    data.date_time_zone = data.date_time_zone ?? 'STZ'

    // The create/update APIs require explicit exit behavior fields.
    data.configuration = data.configuration ?? {}
    data.configuration.end_behavior = data.configuration.end_behavior ?? ExitBehavior.BLEED
    data.configuration.end_status = data.configuration.end_status ?? ExitStatus.COMPLETED
    data.configuration.audience = data.configuration.audience ?? {}
    data.configuration.audience.segment_ids = data.configuration.audience.segment_ids ?? []

    // Coerce schedule.frequency to number — EveryNSchedule (from @pushly/aqe)
    // returns a string from the DOM input, but the API requires a number.
    if (data.configuration?.schedule?.frequency != null) {
        data.configuration.schedule.frequency = Number(data.configuration.schedule.frequency)
    }

    // Strip read-only / server-computed fields
    delete data.revisions
    delete data.revision
    delete data.start_date_utc
    delete data.end_date_utc
    delete data.date_completed_utc
    delete data.manually_completed

    return stripUndefined(data)
}
